/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CityResponseDto } from './CityResponseDto';
import {
    CityResponseDtoFromJSON,
    CityResponseDtoFromJSONTyped,
    CityResponseDtoToJSON,
    CityResponseDtoToJSONTyped,
} from './CityResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListCitiesResponseDto
 */
export interface ListCitiesResponseDto {
    /**
     * 
     * @type {Array<CityResponseDto>}
     * @memberof ListCitiesResponseDto
     */
    data: Array<CityResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListCitiesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListCitiesResponseDto interface.
 */
export function instanceOfListCitiesResponseDto(value: object): value is ListCitiesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListCitiesResponseDtoFromJSON(json: any): ListCitiesResponseDto {
    return ListCitiesResponseDtoFromJSONTyped(json, false);
}

export function ListCitiesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCitiesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CityResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListCitiesResponseDtoToJSON(json: any): ListCitiesResponseDto {
    return ListCitiesResponseDtoToJSONTyped(json, false);
}

export function ListCitiesResponseDtoToJSONTyped(value?: ListCitiesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(CityResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

